import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ConfigureProjectPage } from './configure-project';
import { PipesModule } from '../../../pipes/pipes.module';
import { FoundationModule } from '../../../_foundation/foundation.module';
import { TextMaskModule } from 'angular2-text-mask';
import { SharedModule } from '../../shared/shared.module';
import { DirectivesModule } from '../../../directives/directives.module';
import { IonicSelectableModule } from 'ionic-selectable';

@NgModule({
  declarations: [
    ConfigureProjectPage,
  ],
  imports: [
    IonicPageModule.forChild(ConfigureProjectPage),
    PipesModule,
    FoundationModule,
    TextMaskModule,
    SharedModule,
    DirectivesModule,
    IonicSelectableModule,
  ],
})
export class ConfigureProjectPageModule {
}



// WEBPACK FOOTER //
// ./src/pages/setup/configure-project/configure-project.module.ts